// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { useEffect, useState } from "react";
import { notify } from "@/shared/utils/notify";
import { useNavigate, useLocation } from "react-router-dom";

import { setOrdersForUpdate } from "../../../../redux";
import useAppDispatch from "../../../../redux/hooks/useAppDispatch";
import { ordersService } from "../../../../shared/services";

export const useValidateSingleOrder = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const dispatch = useAppDispatch();
  const [isValidate, setIsValidate] = useState(false);

  const getSingleOrder = async (id: number) => {
    return await ordersService
      .get(id)
      .then((res) => {
        return res;
      })
      .catch((err: any) => {
        console.log(err);
        navigate(`/orders`);
        notify.error(err.message);
      });
  };

  useEffect(() => {
    const orderId = Number(pathname.split("/")[2]);
    if (isNaN(orderId)) return navigate(`/orders`);
    
    // Cargar datos iniciales
    getSingleOrder(orderId).then((res) =>
      dispatch(setOrdersForUpdate(res))
    );
    setIsValidate(true);

    // Polling para refrescar datos cada 2 segundos
    const intervalId = setInterval(() => {
      getSingleOrder(orderId).then((res) =>
        dispatch(setOrdersForUpdate(res))
      );
    }, 2000);

    return () => {
      clearInterval(intervalId);
    };
  }, [pathname, dispatch, navigate]);

  const refreshOrder = async () => {
    const orderId = Number(pathname.split("/")[2]);
    if (!isNaN(orderId)) {
      await getSingleOrder(orderId).then((res) =>
        dispatch(setOrdersForUpdate(res))
      );
    }
  };

  return {
    //state
    isValidate,
    //methods
    refreshOrder,
    //functions
  };
};
